// extracted by mini-css-extract-plugin
export default {"mobileShow":"G8691db Gd99ee9"};